import React, { useState } from 'react'
import styles from './BinancenftMysteryBox.module.scss'
import { Row, Col, Carousel, CarouselItem } from 'react-bootstrap'
import busdIcon from '../../assets/imgs/binanceNFT/icon-busd.png';
import mysteryBox1 from '../../assets/imgs/binanceNFT/mystery-boxes-00.png'
import mysteryBox2 from '../../assets/imgs/binanceNFT/mystery-boxes-nft-ssr01.png'
import mysteryBox3 from '../../assets/imgs/binanceNFT/mystery-boxes-nft-ssr02.png'
import mysteryBox4 from '../../assets/imgs/binanceNFT/mystery-boxes-nft-sr03.png'
import mysteryBox5 from '../../assets/imgs/binanceNFT/mystery-boxes-nft-sr04.png'

const BinancenftMysteryBox = () => {
    const [index, setIndex] = useState(0);
    const mysteryImage = [mysteryBox1,mysteryBox2,mysteryBox3,mysteryBox4,mysteryBox5]
    return (
        <section className={styles.mysteryBox}>
            <div className={styles.mysteryBox_container}>
                <Row className='mx-0 my-0'>
                    <Col sm={12} lg={6} className={`d-flex align-items-center ${styles.item_col}`}>
                        <div className={styles.mysteryBox_desc}>
                            <h3 className={styles.mysteryBox_title}>
                                TOWER Mystery Box
                            </h3>
                            <p className={styles.mysteryBox_text}>
                                TOWER Mystery boxes contain a series of avatar skin NFTs that will provide new, unique appearances for game characters in the upcoming Tower Defense Blockchain Game
                            </p>
                            {/* <p className={styles.mysteryBox_text}>
                                Gold VIP passes will give earliest access to the first 1000 players.
                            </p> */}
                            <h3 className={styles.mysteryBox_price}>
                                <img src={busdIcon} alt="" />
                                10 BUSD
                            </h3>
                        </div>
                    </Col>
                    <Col sm={12} lg={6} className={styles.item_col}>
                        <div className={styles.box_container}>
                            <Carousel activeIndex={index} indicators={false} interval={null} bsPrefix={styles.box_carousel} controls={false} fade>
                                <Carousel.Item bsPrefix={`${styles.box_item} carousel-item`}>
                                    <img className={styles.box_image} src={mysteryBox1} alt="" />
                                </Carousel.Item>
                                <Carousel.Item bsPrefix={`${styles.box_item} carousel-item`}>
                                    <img className={styles.box_image} src={mysteryBox2} alt="" />
                                </Carousel.Item>
                                <Carousel.Item bsPrefix={`${styles.box_item} carousel-item`}> 
                                    <img className={styles.box_image} src={mysteryBox3} alt="" />
                                </Carousel.Item>
                                <Carousel.Item bsPrefix={`${styles.box_item} carousel-item`}>
                                    <img className={styles.box_image} src={mysteryBox4} alt="" />
                                </Carousel.Item>
                                <Carousel.Item bsPrefix={`${styles.box_item} carousel-item`}>
                                    <img className={styles.box_image} src={mysteryBox5} alt="" />
                                </Carousel.Item>
                            </Carousel>
                            <div className={styles.controllers}>
                                {mysteryImage.map((item, idx) => (
                                    <button onClick={() => setIndex(idx)}>
                                        <img src={item} alt='' />
                                    </button>
                                ))}
                            </div>
                            
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export {BinancenftMysteryBox}
